import React from 'react';
import {
  EARTH_MODE_IMPOSSIBLE,
  EARTH_MODE_IMPOSSIBLE_ISH,
} from '../../../constants/games/zoomedInEarthGame';

const MODE_LABELS = Object.freeze({
  [EARTH_MODE_IMPOSSIBLE]: 'Impossible',
  [EARTH_MODE_IMPOSSIBLE_ISH]: 'Impossible-ish',
});

const formatAverage = (entry) => {
  const value = Number(entry?.avgGuessPct);
  if (!Number.isFinite(value)) return '—';
  return `${value.toFixed(1)}%`;
};

const formatGamesPlayed = (entry) => {
  const count = Number(entry?.gamesPlayed);
  if (!Number.isFinite(count) || count <= 0) return '0 games';
  return `${count} game${count === 1 ? '' : 's'}`;
};

const EarthAverageGuessSummary = ({ mode, averages }) => {
  if (!averages) return null;

  const impossible = averages[EARTH_MODE_IMPOSSIBLE];
  const impossibleIsh = averages[EARTH_MODE_IMPOSSIBLE_ISH];
  const currentModeLabel = MODE_LABELS[mode] || 'Current mode';
  const currentModeAverage =
    mode === EARTH_MODE_IMPOSSIBLE ? impossible : impossibleIsh;

  return (
    <div className="earth-average-summary">
      <p className="earth-average-summary-title">
        Your average guess % ({currentModeLabel}):{' '}
        <strong>{formatAverage(currentModeAverage)}</strong>
      </p>
      <p className="earth-average-summary-modes">
        Impossible: <strong>{formatAverage(impossible)}</strong>{' '}
        ({formatGamesPlayed(impossible)})
        {' '}|{' '}
        Impossible-ish: <strong>{formatAverage(impossibleIsh)}</strong>{' '}
        ({formatGamesPlayed(impossibleIsh)})
      </p>
    </div>
  );
};

export default React.memo(EarthAverageGuessSummary);
